const features = [
  {
    icon: 'ri-speed-up-line',
    title: '极速入金提款',
    desc: '支持多种支付方式，入金秒到账，提款最快5分钟处理完成，资金安全有保障',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全保障体系',
    desc: '采用国际顶级加密技术，严格用户隐私保护，通过多项国际安全认证',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '全天候客服支持',
    desc: '7×24小时专业客服团队在线，提供多语言服务，快速解决您的每一个问题',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端同步体验',
    desc: '支持PC网页端、移动网页端、APP客户端多平台无缝切换，随时随地畅享赛事',
  },
  {
    icon: 'ri-fire-line',
    title: '实时赛事赔率',
    desc: '数据实时同步更新，精准赔率体系，让您不错过每一个精彩时刻',
  },
  {
    icon: 'ri-gift-line',
    title: '丰厚优惠活动',
    desc: '新用户注册即享专属福利，日常赛事竞猜还有返现、加码等多重优惠',
  },
];

export default function Features() {
  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            为什么选择开云体育平台
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-[500px] mx-auto">
            六大核心优势，为您打造极致的体育竞技服务体验
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {features.map((feat, i) => (
            <div
              key={i}
              className="group flex gap-4 p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/60 hover:border-primary-200/60 transition-all duration-300"
            >
              <div className="flex-shrink-0 w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${feat.icon} text-xl`}></i>
              </div>
              <div>
                <h3 className="font-heading text-base font-semibold text-foreground-800 mb-1.5">
                  {feat.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{feat.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}